import type { BlockDef } from '../../prop-types.ts'
import { EMPTY_TEXT } from '../../text.ts'

export const image: BlockDef = {
  type: 'image',
  v: 1,
  label: { en: 'Image', ar: 'صورة' },
  scope: 'page',
  description: 'One picture, optionally with a caption. Can sit at half or a third width beside text.',
  whenToUse: 'A single photograph that carries a section — the shopfront, the dish, the team at work.',
  whenNotToUse: 'For several pictures — that is a Gallery, which lays them out and handles a phone screen.',
  variants: [
    { value: 'contained', label: { en: 'With margins', ar: 'مع هوامش' } },
    { value: 'full-bleed', label: { en: 'Edge to edge', ar: 'من الحافة إلى الحافة' } },
  ],
  fields: [
    {
      key: 'image',
      label: { en: 'Image', ar: 'الصورة' },
      type: { kind: 'image' },
      default: { status: 'placeholder', description: EMPTY_TEXT, orientation: 'landscape' },
      requiredForPublish: true,
    },
    { key: 'caption', label: { en: 'Caption', ar: 'التعليق' }, type: { kind: 'text' }, default: EMPTY_TEXT },
  ],
}
